export default __webpack_public_path__ + "static/media/whitepaper.f41e96d0.gif";